import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('s4/registry/page', data)

// 删除
export const remove = id => request().get(`s4/registry/delete/${id}`)

export const update = params =>
  request().post('s4/registry/saveOrUpdate', params)

// 上传
export const upload = params => {
  return request().post('s4/registry/excel/import', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 下载
export const downloadTemplate = () =>
  request().get('s4/registry/template/download', { responseType: 'blob' })
